import React from 'react';
import Text from '@bufferapp/ui/Text';
import Button from '@bufferapp/ui/Button';
import { useAppSelector } from '~/store';
import { selectCurrentOrganizationId } from '~/organizations/selectors';
import { BufferTracker } from '@bufferapp/buffer-tracking-browser-ts';
import useDismissBanner, {
  BannerTypes,
} from '~/profile-page/hooks/useDismissBanner';
import { useDismissedBanners } from '~/accountContext';
import { Layout, Container, ButtonsContainer } from './styles';

export const FollowBufferMastodon = () => {
  const organizationId = useAppSelector((state) =>
    selectCurrentOrganizationId(state)
  );

  const onClick = () => {
    BufferTracker.followMastodonButtonClicked({
      organizationId,
      clientName: 'publishWeb',
      product: 'publish',
    });
    window.open('https://mastodon.world/@buffer', '_blank');
  };

  const dismissedBanners = useDismissedBanners();
  const showMastodonFollowBanner =
    dismissedBanners && !dismissedBanners.includes('followBufferMastodon');

  const { onDismissBanner: onFollowBufferDismiss } = useDismissBanner({
    banner: BannerTypes.followBufferMastodon,
  });

  const onDismissClicked = () => {
    BufferTracker.followMastodonDismissed({
      organizationId,
      clientName: 'publishWeb',
      product: 'publish',
    });
    onFollowBufferDismiss();
  };

  if (!showMastodonFollowBanner) return <></>;

  return (
    <Layout
      dismiss={() => {
        onDismissClicked();
      }}
      type="note"
      disableAnimation
    >
      <>
        <Container>
          <img
            src="https://buffer-publish.s3.amazonaws.com/images/buffer_x_mastodon_badge.svg"
            alt="Buffer x Mastodon"
            height={24}
          />
          <Text type="h3">Looking for some new friends on Mastodon?</Text>
          <Text type="p">
            Follow us for news and tips about growing your presence.
          </Text>
          <ButtonsContainer>
            <Button
              type="primary"
              size="small"
              label="Follow Buffer on Mastodon"
              onClick={onClick}
            />
          </ButtonsContainer>
        </Container>
        <img
          src="https://buffer-publish.s3.amazonaws.com/images/mastodon-promo-banner-image.png"
          alt="Mastodon Promo Banner"
          width={358}
        />
      </>
    </Layout>
  );
};
